import {useMemo, useEffect, useState} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {tableColumns} from './columns/_columns'
import {PersonsListPagination} from '../components/pagination/ListPagination'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import { IVerification } from '../../interfaces/IVerification'
import { UsersListLoading } from '../components/loading/ListLoading'

type Props = {
    data: any
    loading: boolean
}

const PersonsTable: React.FC<Props> = ({data, loading}) => {
    const [totalCount, setTotalCount] = useState(0)
    const [limit, setLimit] = useState(500)
    const [itemsPerPage, setItemsPerPage] = useState(20)
    const [activePage, setActivePage] = useState(1)
    const [tableData, setTableData] = useState([])

    const columns = useMemo(() => tableColumns, [])
    const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
        columns,
        data: tableData
    })

    useEffect(() => {
        setTableData(data?.slice((activePage * itemsPerPage) - itemsPerPage, (activePage * itemsPerPage)) || [])
        if (data?.length <= itemsPerPage) {
            setTableData(data?.slice(0, (1 * itemsPerPage)))
        }

        if (data) {
            setTotalCount(data.length)
            setLimit(data.length)
        }
    }, [data, itemsPerPage, activePage]);

    return (
        <KTCardBody className='py-4'>
            <div className='table-responsive'>
                <table
                    id='kt_table_users'
                    className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer table-hover'
                    {...getTableProps()}
                >
                    <thead>
                    <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
                        {headers.map((column: ColumnInstance<IVerification>) => (
                            <CustomHeaderColumn key={column.id} column={column}/>
                        ))}
                    </tr>
                    </thead>
                    <tbody className='text-gray-600 fw-bold' style={{cursor: 'pointer'}} {...getTableBodyProps()}>
                    {loading &&
                        <tr>
                            <td colSpan={7}>
                                <UsersListLoading/>
                            </td>
                        </tr>
                    }

                    {!loading &&
                        <>
                            {rows.length > 0 ? (
                                rows.map((row: Row<IVerification>, i) => {
                                    prepareRow(row)
                                    return <CustomRow row={row} key={`row-${i}-${row.id}`}/>
                                })
                            ) : (
                                <tr>
                                    <td colSpan={7}>
                                        <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                                            No matching records found
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </>
                    }
                    </tbody>
                </table>
            </div>
            {rows.length > 0
                && <PersonsListPagination
                    activePage={activePage}
                    itemsPerPage={itemsPerPage}
                    setItemsPerPage={setItemsPerPage}
                    setActivePage={setActivePage}
                    totalCount={totalCount}
                    limit={limit}
                />
            }
        </KTCardBody>
    )
}

export {PersonsTable}
